import React, { useState } from "react";
import { Container, Row } from "reactstrap";
import styles from "./PromotionalMaterials.module.scss";
import DynamicFilterBar from "../../../components/common/AdminCommonComponents/FilterBars/DynamicFilterBar/DynamicFilterBar";
import PromotionalLinks from "../../../components/AffiliatePortalComponents/PromotionalMaterials/PromotionalLinks/PromotionalLinks";
import PromotionalResources from "../../../components/AffiliatePortalComponents/PromotionalMaterials/PromotionalResources/PromotionalResources";

const tabsData = [
    { key: "1", label: "Promotional Links" },
    { key: "2", label: "Promotional Resources" },
];

const PromotionalMaterials = () => {
    const [activeTab, setActiveTab] = useState(tabsData[0]?.key || "");

    return (
        <Container fluid className={styles.promotionalMaterialsContainer}>
            <Row className={styles.filterBarRow}>
                <DynamicFilterBar
                    filterTabs={tabsData}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    barType="red-bar"
                />
            </Row>

            {activeTab === "1" && <PromotionalLinks />}
            {activeTab === "2" && <PromotionalResources />}
        </Container>
    );
};

export default PromotionalMaterials;